import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Reveal } from './Reveal';
import { INVESTOR } from '@/constants/testIds';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '' });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Merci de renseigner votre nom, votre email et un message.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success('Message envoyé. Zukunft Real Estate GmbH vous répondra personnellement.');
      setForm({ name: '', email: '', company: '', message: '' });
    } catch (err) {
      toast.error("L'envoi a échoué. Merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      data-testid={INVESTOR.contact}
      className="bg-[#0c0e12] border-t border-border"
    >
      <div className="mx-auto max-w-screen-2xl px-6 md:px-12 py-32 md:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="overline">04 — Prendre contact</span>
              <h2 className="mt-6 font-display font-light tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-foreground">
                Vous levez.
                <br />
                <span className="italic text-primary">Parlons-en.</span>
              </h2>
              <p className="mt-8 max-w-sm font-body font-light leading-relaxed text-muted-foreground">
                Une idée, un deck, une question sur un tour de table. Écrivez
                directement — chaque message est lu.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-10">
                <div>
                  <label className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
                    Nom
                  </label>
                  <input
                    data-testid={INVESTOR.contactName}
                    className="flair-input mt-2"
                    placeholder="Votre nom"
                    value={form.name}
                    onChange={update('name')}
                  />
                </div>
                <div>
                  <label className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
                    Email
                  </label>
                  <input
                    data-testid={INVESTOR.contactEmail}
                    type="email"
                    className="flair-input mt-2"
                    placeholder="vous@societe.com"
                    value={form.email}
                    onChange={update('email')}
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
                    Société <span className="text-muted-foreground lowercase">(optionnel)</span>
                  </label>
                  <input
                    data-testid={INVESTOR.contactCompany}
                    className="flair-input mt-2"
                    placeholder="Nom de votre startup"
                    value={form.company}
                    onChange={update('company')}
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
                    Message
                  </label>
                  <textarea
                    data-testid={INVESTOR.contactMessage}
                    rows={4}
                    className="flair-input mt-2 resize-none"
                    placeholder="Parlez-moi de votre projet…"
                    value={form.message}
                    onChange={update('message')}
                  />
                </div>

                <div className="md:col-span-2">
                  <button
                    type="submit"
                    disabled={loading}
                    data-testid={INVESTOR.contactSubmit}
                    className="group relative inline-flex items-center gap-3 border border-primary px-9 py-4 font-mono text-[0.7rem] uppercase tracking-[0.24em] text-primary overflow-hidden disabled:opacity-60"
                  >
                    <span className="absolute inset-0 bg-primary translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.19,1,0.22,1)]" />
                    <span className="relative group-hover:text-primary-foreground transition-colors duration-500">
                      {loading ? 'Envoi…' : 'Envoyer le message'}
                    </span>
                  </button>
                </div>
              </form>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
